import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "orders-table-filter_results-km header-wrapper text-raleway-14 bb-solid-blue100 bt-solid-blue100 w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_4 = {
  key: 0,
  class: "top arrow"
}
const _hoisted_5 = {
  key: 1,
  class: "down arrow"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "down arrow" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("article", { class: "orders-table-header photo pointer" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Photo")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_12 = {
  key: 0,
  class: "top arrow"
}
const _hoisted_13 = {
  key: 1,
  class: "down arrow"
}
const _hoisted_14 = {
  key: 1,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "down arrow" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "text-center w-100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex direction-column arrow-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }),
  /*#__PURE__*/_createElementVNode("div", { class: "down arrow" })
], -1)
const _hoisted_20 = { class: "text-center w-100 text-overflow_ellipsis" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_22 = {
  key: 0,
  class: "top arrow"
}
const _hoisted_23 = {
  key: 1,
  class: "down arrow"
}
const _hoisted_24 = {
  key: 1,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "down arrow" }, null, -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_29 = {
  key: 0,
  class: "top arrow"
}
const _hoisted_30 = {
  key: 1,
  class: "down arrow"
}
const _hoisted_31 = {
  key: 1,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "down arrow" }, null, -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_36 = {
  key: 0,
  class: "top arrow"
}
const _hoisted_37 = {
  key: 1,
  class: "down arrow"
}
const _hoisted_38 = {
  key: 1,
  class: "d-flex direction-column arrow-wrapper"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "top arrow" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "down arrow" }, null, -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "orders-table-header status" }
const _hoisted_43 = { class: "orders-table-header status" }
const _hoisted_44 = { class: "orders-table-header status text-center" }

import { IStore } from "@/store/types/StoreType";
import { useField } from "vee-validate";
import { useStore } from "vuex";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'filterResultsComponent_KM',
  setup(__props) {

const check = ref(true);
const position = ref("");
const field = useField("ordering");

const store = useStore<IStore>();
const searchCars = ref(
  computed<boolean>(() => store.getters.getSearchStateCars)
);
const searchTruck = ref(
  computed<boolean>(() => store.getters.getSearchStateTruck)
);
const valueSelectFilter = ref(
  computed<string>(() => store.getters.getSelectFilter)
);

const changeFilter = (filter: string) => {
  if (filter === field.value.value) {
    position.value = check.value ? "-" : "";
    check.value = !check.value;
  } else {
    check.value = true;
    position.value = "";
  }

  field.value.value = position.value + filter;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["text-motserrat-14 d-flex a-i-center j-content-center w-100 mt-2 position-sticky orders-results bg-white", {
      'orders-results_close':
        (!searchCars.value && valueSelectFilter.value === 'Cars') ||
        (!searchTruck.value && valueSelectFilter.value === 'Truck'),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeFilter('item_no'))),
        class: "orders-table-header model pointer text-raleway-14 pointer b-none bg-none"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Item number")), 1),
        (_unref(field).value.value === 'item_no' || _unref(field).value.value === '-item_no')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (position.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
      ]),
      _hoisted_10,
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeFilter('full_name'))),
        class: "orders-table-header full_name pointer j-content-start text-raleway-14 pointer b-none bg-none"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tyre name")), 1),
        (
            _unref(field).value.value === 'full_name' ||
            _unref(field).value.value === '-full_name'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (position.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : (_openBlock(), _createElementBlock("div", _hoisted_13))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeFilter('stock_name'))),
        class: "orders-table-header full_name pointer j-content-start mr-1 ml-1 text-raleway-14 pointer b-none bg-none"
      }, [
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Stock name")), 1),
        _hoisted_19
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeFilter('delivery_time'))),
        class: "orders-table-header full_name pointer j-content-start mr-1 ml-1 text-raleway-14 pointer b-none bg-none text-overflow_ellipsis"
      }, [
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("Delivery time")), 1),
        (
            _unref(field).value.value === 'delivery_time' ||
            _unref(field).value.value === '-delivery_time'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (position.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                : (_openBlock(), _createElementBlock("div", _hoisted_23))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
      ]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeFilter('current_price'))),
        class: "orders-table-header price pointer text-raleway-14 pointer b-none bg-none"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Price")), 1),
        (
            _unref(field).value.value === 'current_price' ||
            _unref(field).value.value === '-current_price'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (position.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                : (_openBlock(), _createElementBlock("div", _hoisted_30))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
      ]),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (changeFilter('amount'))),
        class: "orders-table-header pointer text-raleway-14 pointer b-none bg-none"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Stock")), 1),
        (
            _unref(field).value.value === 'amount' || _unref(field).value.value === '-amount'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (position.value === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                : (_openBlock(), _createElementBlock("div", _hoisted_37))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41))
      ]),
      _createElementVNode("article", _hoisted_42, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Quantity")), 1)
      ]),
      _createElementVNode("article", _hoisted_43, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Margin")), 1)
      ]),
      _createElementVNode("article", _hoisted_44, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Price for the end buyer")), 1)
      ])
    ])
  ], 2))
}
}

})